import React from "react";
import { ChipField } from "react-admin";

export const ValueChip = ({ value, link, style, chipStyle }) => {
	if (!value) return null;
	const chip = <ChipField record={{ value }} source="value" size="small" style={chipStyle} />;
	if (!link) return chip;
	return (
		<a
			href={link}
			target="_blank"
			rel="noopener noreferrer"
			style={{ textDecoration: "none", ...style }}
			onClick={(e) => e.stopPropagation()}
		>
			{chip}
		</a>
	);
};
